<template>
    <form>
        <div class="bet-name">
            <span>{{'system_bet' | translate }}</span>
        </div>
        <div class="bet-area">
            <input  v-model="bettingSvc.system"
                    id="system"
                    type="number"
                    v-system-bet-validator
                    @keydown="checkChars"
                    @keydown.enter.prevent="setFocus()"
                    @keydown.tab.prevent="setFocus()"
                    autocomplete="off"
                    :disabled="isBettingDisabled"
            >
            <label v-if="bettingSvc.currentNumberOfSystems && bettingSvc.currentNumberOfSystems > 1">
                <span>/</span>
                <span>{{bettingSvc.currentNumberOfSystems}}</span>
            </label>
            <label v-if="!bettingSvc.currentNumberOfSystems || bettingSvc.currentNumberOfSystems <= 1 ">
                <span>{{ 'system_no_combinations' | translate}}</span>
            </label>
        </div>
    </form>
</template>

<script>
import { BettingSvc } from '../../../services/betting.service';
import { SystemBetValidator } from '../../../directives/systembet_validator';
import { EventBus } from '../../../utilities/event.bus';
import { invalidChars } from '../../../utilities/invalidCharsChecker';
import {translate} from '../../../filters/translate';
import {GameSvc} from '../../../services/game.service';

let systemBet;

export default {
    name: 'SystemBet',

    filters: {
        translate,
    },

    directives: {
        SystemBetValidator,
    },

    data() {
        return {
            bettingSvc : BettingSvc.getBettingSvc(),
            system_bet : 'system_bet'
        };
    },
    computed: {
        isBettingDisabled () {
            return GameSvc.getGameSvc().gameInfo.betsBlocked;
        }
    },

    mounted() {
        systemBet =  document.getElementById('system');
    },

    methods: {
        checkChars(event) {
            invalidChars(event);
        },

        /**
         * Set focus on right input
         */
        setFocus() {
            let futureBet = document.getElementById('future');

            // if future bet is not active resolve bet
            if (systemBet.value && !futureBet) {
                try {
                    this.bettingSvc.finalizeTicket();
                } catch (err) {
                    return;
                }

                this.resetAll();
                return;
            }

            // if future bet is active set focus on it
            if (futureBet) {
                futureBet.select();
            }
        },

        /**
         * Reset betting service and activate normal bet
         */
        resetAll() {
            this.bettingSvc.clearAll();
            EventBus.$emit('keydown',{
                key : '+'
            });
        },
    }
};
</script>

<style  lang="scss">
    @import '../../../assets/style/shop/betting';
</style>



// WEBPACK FOOTER //
// SystemBet.vue?3e42951b